export const whiteLabelGroup = {
  GET_WHITE_LABEL_GROUP_FETCHING: "GET_WHITE_LABEL_GROUP_FETCHING",
  GET_WHITE_LABEL_GROUP_SUCCESS: "GET_WHITE_LABEL_GROUP_SUCCESS",
  GET_WHITE_LABEL_GROUP_ERROR: "GET_WHITE_LABEL_GROUP_ERROR",
  GET_WHITE_LABEL_GROUP_INVALIDATE: "GET_WHITE_LABEL_GROUP_INVALIDATE",
  GET_WHITE_LABEL_GROUP_CLEAR: "GET_WHITE_LABEL_GROUP_CLEAR",
};

export const whiteLabelConfig = {
  GET_WHITE_LABEL_CONFIGS_FETCHING: "GET_WHITE_LABEL_CONFIGS_FETCHING",
  GET_WHITE_LABEL_CONFIGS_SUCCESS: "GET_WHITE_LABEL_CONFIGS_SUCCESS",
  GET_WHITE_LABEL_CONFIGS_ERROR: "GET_WHITE_LABEL_CONFIGS_ERROR",
  GET_WHITE_LABEL_CONFIGS_INVALIDATE: "GET_WHITE_LABEL_CONFIGS_INVALIDATE",
  GET_WHITE_LABEL_CONFIGS_CLEAR: "GET_WHITE_LABEL_CONFIGS_CLEAR",
};
